// REQ-FE-029f — `Distribution des délais de paiement` histogram. Same
// placeholder pattern as StatusMixChart: no contract field today, so
// surface the expected buckets and a REQ-BE-follow-up hint.

const BUCKETS: Array<{ key: string; label: string }> = [
  { key: 'avance-30', label: '< 30 j avance' },
  { key: 'avance-14-29', label: '-14 à -29 j' },
  { key: 'avance-7-13', label: '-7 à -13 j' },
  { key: 'on-time', label: '0 à -6 j' },
  { key: 'retard-1-7', label: '1 à 7 j retard' },
  { key: 'retard-7-plus', label: '> 7 j retard' },
];

export function PaymentDelayHistogram() {
  return (
    <div
      className="tenant-stats__histogram"
      data-testid="tenant-stats-histogram-placeholder"
      aria-label="Distribution des délais de paiement — données à venir"
    >
      <div className="tenant-stats__histogram-bars">
        {BUCKETS.map((b) => (
          <div
            key={b.key}
            className="tenant-stats__histogram-col"
            data-testid={`tenant-stats-histogram-${b.key}`}
          >
            <div className="tenant-stats__histogram-bar" aria-hidden="true" />
            <div className="tenant-stats__histogram-count muted">—</div>
            <div className="muted tenant-stats__histogram-label">{b.label}</div>
          </div>
        ))}
      </div>
      <p className="muted tenant-stats__hint">
        Délais effectifs vs échéance disponibles après ajout du champ `paymentDelayDistribution` sur
        `TenantKpis` (REQ-BE à venir).
      </p>
    </div>
  );
}
